import { reactive, toRefs, nextTick } from 'vue'
import { mergeDeep } from '@/common/js/utils.js'
import { clone } from '@/common/js/just.js'
import { getTitleLibsByIds, getTargetingLibsByIds } from '@/api/ptom.data.model'
import { getConfigFormModel } from '../model/form.js'
import { budgetForm as budgetFormModel } from '@/views/create/gdt/model/budget/budget-form.js'

/**
 * @description: 根据id获取模板内定向包、文案包最新数据
 * @return {*}
 */
export const getUpdatedLibInfoById = async (form) => {
  const { descriptions, targetings, planForm } = form

  const descriptionsIds = descriptions.map((i) => i.id)
  const targetingsIds = targetings.map((i) => i.targetingId)

  const res = {
    descriptions: [],
    targetings: []
  }

  try {
    if (descriptionsIds.length) {
      const data = await getTitleLibsByIds({ ids: descriptionsIds })
      res.descriptions = data.map((i) => ({ ...i, content: JSON.parse(i.content) }))
    }

    if (targetingsIds.length) {
      const data = await getTargetingLibsByIds({ ids: targetingsIds })
      res.targetings = data
    }
    return res
  } catch (e) { }
}

/**
 * @description: 模板选择
 * @return {*}
 */
export const useTemplateManage = (configForm) => {
  const templateManageModel = reactive({
    selectedTemplateInfo: {},
    onTemplateSelectLoading: false
  })

  async function onTemplateConfirm(row) {
    templateManageModel.onTemplateSelectLoading = true
    templateManageModel.selectedTemplateInfo = row
    // 模拟加载
    setTimeout(() => {
      templateManageModel.onTemplateSelectLoading = false
    }, 600)

    try {
      // 先进行一次清空，防止定向包更改参数后，由于v-for使用的key:targetingId没有变化而导致页面不更新
      configForm.value = getConfigFormModel()
      await nextTick()
      const form = JSON.parse(row.conditionInfo)
      const { descriptions, targetings } = await getUpdatedLibInfoById(form)

      // 过滤掉老的素材模板组图创意，防止创意素材弹窗卡死。
      const creatives = form.creatives.map((i) => {
        const { image_list } = i.selectedMaterials
        const [firstItem] = image_list || []
        // 如果firstItem.id为真，则是新版组图素材，否则是老版本组图素材
        if (firstItem?.id) {
          return i
        }
        return {
          ...i,
          selectedMaterials: {
            ...i.selectedMaterials,
            image_list: []
          }
        }
      })

      const mergedForm = mergeDeep({
        ...configForm.value,
        budgetForm: clone(budgetFormModel)
      }, form, {
        creatives,
        descriptions,
        targetings
      })

      return {
        ...configForm.value,
        ...mergedForm
      }
    } catch (e) {
      console.log('eeeeeeeeee output: ', e)
    }
  }

  return {
    ...toRefs(templateManageModel),
    onTemplateConfirm
  }
}
